<app-dialog
  [title]="'Sku Generate'"
  [actions]="[
    { text: 'Add',isDisabled : input.invalid}
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <div class="update-qty mt-4">
    <div class="input-container generateSku">
      <label for="" class="input-container_label">Sku</label>
      <input
        type="text"
        class="input-container_input"
        [formControl]="input"
        placeholder="(Optional)"
      />
      <i
        class="fal generateSku_copy"
        [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
        [cdkCopyToClipboard]="input.value"
        (cdkCopyToClipboardCopied)="copy($event)"
    ></i>
    </div>
  </div>
</app-dialog>